import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Route, Router, UrlTree } from '@angular/router';

/// An address that moved, followed inside the app: to `data.movedTo` with the query string and fragment kept - the
/// order emails link /contact-us?topic=order&order=..., and redirectTo would drop the query. The server answers the
/// same old addresses with a 301 (SeoMiddleware), so this is for links clicked inside the app only.
@Injectable({
    providedIn: 'root'
})
export class MovedGuard implements CanActivate {
    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): UrlTree {
        // In the address's language: /bn/about-us moves to /bn/about (data.lang, from the /bn copy of the routes).
        const lang = route.data.lang && route.data.lang !== 'en' ? route.data.lang : '';
        return this.router.createUrlTree([(lang ? '/' + lang : '') + route.data.movedTo], {
            queryParams: route.queryParams,
            fragment: route.fragment || undefined,
        });
    }
}

/// The route for an address that moved: `path` (exactly) to `to`, query kept.
export function moved(path: string, to: string): Route {
    return { path, pathMatch: 'full', canActivate: [MovedGuard], data: { movedTo: to }, children: [] };
}
